// extracted by mini-css-extract-plugin
export var label = "SimpleTable-module--label--db+Aj";
export var table = "SimpleTable-module--table--Un0bf";